import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import pathnames from './routes/index.route';
import SignIn from './pages/Auth/SignIn';
import AllSet from './pages/AllSet';
import InitialInfo from './pages/Auth/InitialInfo';
import Layout from './layout';
import Accounts from './pages/Accounts';
import SpecificGroup from './pages/SpecificGroup';
import SpecificAccount from './pages/SpecificAccount';
import Files from './pages/Files';
import SpecificFileGroup from './pages/SpecificFileGroup';
import Settings from './pages/Settings';
import SchedulePublish from './pages/SchedulePublish';
import UpgradePlan from './pages/Settings/UpgradePlan';
import NotFound from './pages/NotFound';
import ScheduledPost from './pages/ScheduledPost';
import MainLoader from './components/MainLoader';

import { Auth0Provider } from '@auth0/auth0-react';
import { SnackbarProvider } from './components/snackbar/SnackbarProvider';
import { Auth0Callback } from './components/auth/Auth0Callback';
import { PrivateRoute } from './components/PrivateRoute';
import MissingEnvVars from './env-validation';
import { getConfig } from './config';

function App() {
  // const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => setLoading(false), 1500)
    };
    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }
    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path={pathnames.callback} element={<Auth0Callback />} />

          <Route path={pathnames.home} element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route path={pathnames.home} element={<Home />} />
            <Route path={pathnames.accounts} element={<Accounts />} />
            <Route path={pathnames.accounts + pathnames.specificGroup} element={<SpecificGroup />} />
            <Route path={pathnames.accounts + pathnames.specificAccount} element={<SpecificAccount />} />
            <Route path={pathnames.content} element={<Files />} />
            <Route path={pathnames.content + pathnames.specificFileGroup} element={<SpecificFileGroup />} />
            <Route path={pathnames.settings} element={<Settings />} />
            <Route path={pathnames.settings + pathnames.UpgradePlan} element={<UpgradePlan />} />
            <Route path={pathnames.scheduledPost} element={<ScheduledPost />} />
          </Route>
          <Route path={pathnames.schedulePublish} element={<SchedulePublish />} />
          <Route path={pathnames.signIn} element={<SignIn />} />
          <Route path={pathnames.initialInfo} element={<InitialInfo />} />
          <Route path={pathnames.allSet} element={<AllSet />} />
          <Route path={pathnames.notFound} element={<NotFound />} />
        </Routes>
      </Router>
      {loading && <MainLoader />}
    </>
  );
}



function AppWrapper() {
  const { config, missingEnvVars } = getConfig();

  if (missingEnvVars.length > 0) {
    return <MissingEnvVars missingVars={missingEnvVars} />;
  }

  return (
    <Auth0Provider
      domain={config!.auth0.domain}
      clientId={config!.auth0.clientId}
      authorizationParams={{
        redirect_uri: config!.auth0.callbackUrl,
        audience: config!.auth0.audience,
        scope: 'openid profile email'
      }}
      cacheLocation="localstorage"
    >
      <SnackbarProvider>
        <App />
      </SnackbarProvider>
    </Auth0Provider>
  );
}

export default AppWrapper;